site.extras.filter = {
	init:function(layout) {
		layout = typeof layout !== 'undefined' ? layout : 'fitRows';

		$("#extrasItemFilter").appendTo(".submenu ul");
		$("#extrasItemFilter").wrap("<li></li>");

		$('#itemFilter').change(function () {
			var val = $(this).find("option:selected").val();
			var scrollTop = $(window).scrollTop();
			location.hash = val;
			window.scrollTo(0, scrollTop);
		});
		$(window).load(function () {
			var $container = $('#extras .items');
			$container.isotope({
				// options
				itemSelector: '.item',
				layoutMode: layout,
				hiddenStyle: {
					opacity: 0
				},
				visibleStyle: {
					opacity: 1
				}
			});
			$container.addClass('loaded');
		});
		$(function () {
			$(window).bind("hashchange", function (e) {
				$('#itemFilter li').removeClass('selected');
				var b = location.hash;
				b = (b == '') ? '#all' : b;

				if (b) {
					b = b.substr(1, b.length);
					var filterValue = (b == 'all') ? '*' : '.' + b;
					var $container = $('#extras .items');
					$container.isotope({filter: filterValue});
					//$('.categories li').removeClass('selected');
					//$(".categories ." + b).addClass('selected');
					$("#itemFilter ." + b).attr('selected', 'selected');
					$("#itemFilter ." + b).addClass('selected');
				}
			});
			$(window).trigger("hashchange");
		});

		$('a.toggleDetails').on('click touchStart', function(e) {
			e.preventDefault();
			$(this).parents('.item').toggleClass('open');
			setTimeout(function() {
				$('#extras .items').isotope( 'layout' );
			},400);
		});
	},
	initMultiple:function(layout) {
		layout = typeof layout !== 'undefined' ? layout : 'fitRows';
		var $container = $('#extras .items'),
			filters = {};

		$container.isotope({
			itemSelector : '.item',
			layoutMode: layout,
			hiddenStyle: {
				opacity: 0
			},
			visibleStyle: {
				opacity: 1
			}

		});

		// filter buttons
		$('#itemFilter a').click(function(){
			var $this = $(this);
			var $optionSet = $this.parents('.option-set');

			// remove selected
			if ( $this.hasClass('selected') ) {
				// change selected class
				var $optionSet = $this.parents('.option-set');
				var group = $optionSet.attr('data-filter-group');
				$this.removeClass('selected');
				delete filters[group];
			}
			else {
				// change selected class
				var $optionSet = $this.parents('.option-set');
				$optionSet.find('.selected').removeClass('selected');
				$this.addClass('selected');

				// store filter value in object
				var group = $optionSet.attr('data-filter-group');
				filters[group] = $this.attr('data-filter-value');

			}

			// convert object into array
			var isoFilters = [];
			for (var prop in filters) {
				isoFilters.push(filters[prop])
			}
			var selector = isoFilters.join('');
			$container.isotope({filter: selector});

			site.extras.torgLabels($this);
			return false;
		});
	},
	initToggleButton: function() {
		$filter = $('#extras #itemFilter');
		var $body = $('body');
		$('#multiCheckToggle').on('click', function (e) {
			e.preventDefault();
			e.stopPropagation();
			var $this = $(this);

			if(!$filter.hasClass('open')) {
				$body.toggleClass('filter-open');
				$filter.addClass('open');
				$this.addClass('open');
				$('body.filter-open').on('click', function (e) {
					site.extras.filter.closeToggleButton($body,$filter,$this);
				});
			}
			else {
				site.extras.filter.closeToggleButton($body,$filter,$this);
			}
		});
	},
	closeToggleButton: function(body,filter,link) {
		body.removeClass('filter-open');
		filter.removeClass('open');
		link.removeClass('open');
	}
};
//site.inits.push('site.extras.filter.init()');